package pwgs.ui.scenes.logoutscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class ALogoutControllerFe(props: pwgs.ui.scenes.logoutscene.LogoutSceneProps, scene: MLogoutScene)
 : AController<pwgs.ui.scenes.logoutscene.LogoutSceneProps, pwgs.ui.scenes.logoutscene.LogoutSceneModel, LogoutSceneState>(props, scene) {

    val backend = LogoutControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_logout(redirectUrl: kotlin.String) {
        launchOnDefaultControllerScope {
            render(backend.logout(redirectUrl))
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class LogoutControllerBeProxy(private val controller: ALogoutControllerFe) {

    suspend fun logout(redirectUrl: kotlin.String): pwgs.ui.scenes.logoutscene.LogoutSceneModel {
        @Serializable
        class ParamsWrapper(val redirectUrl: kotlin.String)
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper(redirectUrl))
        val p = RmiParams(
            action = "pwgs.ui.scenes.logoutscene.LogoutControllerBe.logout",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.logoutscene.LogoutSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.logoutscene.LogoutSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.logoutscene.LogoutSceneModel.serializer())
        }
    }

}
